import React , { useState,useEffect }from 'react'
import { Button,  Form, Input,message, Space,Modal,Select,Radio, } from 'antd';
// import Icon,{EditOutlined  } from '@ant-design/icons';
// import './index.css';
import {api_tenant_edit_microsoft, api_testmicrosoft} from '../../../api';

// const navigate = useNavigate();
  // navigate(-1)//适用于返回上级页面
  // navigate('/router');//也可直接加路径

const { Option } = Select;
const screenHeight = document.body.clientHeight;

const App =(props)=>{
    const {showModal, closeModal, rowInfo, refreshlist} = props;
    console.log('1111111111111111tenant_edit_microsoft111111111111111111111-', rowInfo)
    const [form] = Form.useForm();
    const [loading,setLoading] = useState(false);
    const [testLoading,setTestLoading] = useState(false);
    const [showMicrosoft,setShowMicrosoft] = useState(false);
    const [microsoftOk,setMicrosoftOk] = useState(false);
    // const [microsortOk,setMicrosortOk] = useState(false);

    useEffect(() => {
      if(showModal){
        if(rowInfo.tenant_id == undefined){
          form.resetFields();
        } else {
          for (let key in rowInfo) {
              form.setFieldValue(key, rowInfo[key])
          }
          if(rowInfo['is_outlook_enabled'] == '1')
            setShowMicrosoft(true);
          else
            setShowMicrosoft(false);
        }
      }else{
        form.resetFields();
        setLoading(false);
        setTestLoading(false);
        setShowMicrosoft(false);
        setMicrosoftOk(false);
      }
    }, [showModal]);

    const onChangeMicrosoft = (e) => {
      console.log(e);
      if(e.target.value=='1')
        setShowMicrosoft(true);
      else
        setShowMicrosoft(false);
    };

    // 点击测试按钮
    const testMicrosoft = async()=>{
      await form.validateFields();

      var microsort = form.getFieldValue("microsort");
      console.log(microsort);
      setTestLoading(true);
      try {
        await api_testmicrosoft({tenant_id:rowInfo.tenant_id, microsort:microsort}).then((res) => {
          setTestLoading(false);
          console.log('api_testmicrosoft-res-----------------', res);
          if (res.data.code == 9) {
            message.success("测试成功");
            setMicrosoftOk(true);
          }else{
            message.error(res.data.msg);
            setMicrosoftOk(false);
          }
        });
        } catch (error) {
          message.error("其他异常-"+error);
          setTestLoading(false);
          setMicrosoftOk(false);
          return false;
        }
    }

    const onFinish = async(value)=>{
      console.log(value);

      // if(value.is_outlook_enabled=='1' && !value.microsort){
      //   message.warn("请输入微软配置");
      //   return false;
      // }
      if(value.is_outlook_enabled=='1' && !microsoftOk){
        message.warn("请先测试微软配置是否正确");
        return false;
      }

      value.tenant_id = rowInfo.tenant_id;

      try {
        await api_tenant_edit_microsoft(value).then((res) => {
          setLoading(false);
          console.log('api_tenant_edit_microsoft-res-----------------', res);
          if (res.data.code == 9) {
            message.success("操作成功");
            closeModal();
            refreshlist();
          }else
            message.error(res.data.msg);
        });
        } catch (error) {
          message.error("网络异常");
          setLoading(false);
          return false;
        }
  }

    //发布(字段没填写完整)
    const onFinishFailed = async (e) => {
    // console.log(e.errorFields[0].name)
        // form.scrollToField(e.errorFields[0].name) // 滚动到对应字段位置
      setTimeout(()=>{
          document.querySelector('.ant-form-item-has-error')?.scrollIntoView({behavior: 'smooth', block: 'center'});
      }, 100)
  }

  return (
    <Modal 
        key="tenantinfo"
        title={"配置微软权限"}
        open={showModal}
        width={"70%"}
        bodyStyle={{maxHeight:screenHeight*0.8,overflowY:"scroll"}}
        centered
        destroyOnClose={true}
        maskClosable={false}
        footer={[<Button  className="m-btn-white" onClick={closeModal}>
        取消
        </Button>,
        <Button type="primary" loading={loading} style={{ marginLeft:'20px',backgroundColor:"rgb(24,188,156)"}} onClick={()=>{form.submit()}}>
        确认
        </Button>] }
        onCancel={closeModal}>
          <Form form={form}
            className='loginForm reginfo'
            name="tenant_edit_microsoft"
            // labelCol={{span: 5}}
            // wrapperCol={{span: 16}}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="horizontal"
            autoComplete="off"
            labelAlign="left"
            labelCol={{span:5}}
            // style={{fontSize:12}}
            size="small"
            initialValues={{
              is_outlook_enabled:"0",
              microsort:{azureCloudUrl:'2'}
            }}
        >

            <Form.Item
                label="开通微软授权"
                name="is_outlook_enabled"
            >
              <Radio.Group style={{width:"80%"}} onChange={onChangeMicrosoft}>
                <Space size={10}>
                <Radio value={"0"}>未开通</Radio>
                <Radio value={"1"}>已开通</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>

            <Form.Item
                label="微软配置"
                name="microsort"
                style={{display:showMicrosoft?"":"none"}}
            >
              <Button type="primary" loading={testLoading} style={{marginBottom:20}} onClick={testMicrosoft} disabled={microsoftOk?true:false}>测试</Button>
              <Form.Item
                  label="clientId"
                  name={['microsort', 'clientId']}
                  labelCol={{span:5}}
                  rules={[
                    {required: showMicrosoft?true:false, message: '请输入clientId',},
                  ]}
              >
              <Input disabled={microsoftOk?true:false} />
              </Form.Item>
              <Form.Item
                  label="tenantId"
                  name={['microsort', 'tenantId']}
                  labelCol={{span:5}}
                  rules={[
                    {required: showMicrosoft?true:false, message: '请输入tenantId',},
                  ]}
              >
              <Input disabled={microsoftOk?true:false} />
              </Form.Item>
              <Form.Item
                  label="clientSecret"
                  name={['microsort', 'clientSecret']}
                  labelCol={{span:5}}
                  rules={[
                    {required: showMicrosoft?true:false, message: '请输入clientSecret',},
                  ]}
              >
              <Input disabled={microsoftOk?true:false} />
              </Form.Item>
              <Form.Item
                  label="azureCloudUrl"
                  name={['microsort', 'azureCloudUrl']}
                  labelCol={{span:5}}
                  rules={[
                    {required: showMicrosoft?true:false, message: '请选择azureCloudUrl',},
                  ]}
              >
              <Select disabled={microsoftOk?true:false}>
                  <Option value={'2'}>中国</Option>
                  <Option value={'1'}>国际</Option>
              </Select>

              </Form.Item>
            </Form.Item>

        </Form>
        </Modal>
  )
}
export default App
